import axios from "axios";

export const getBlogData = async () => {
  return await axios
    .get("https://www.samvednacare.com/blog/wp-json/wp/v2/posts")
    .then((res) => res)
    .catch((err) => err);
};
